module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [(_vm.testimony) ? _c('timeline', {
    ref: "timeline",
    attrs: {
      "id": _vm.testimony._id,
      "testimony": _vm.testimony
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e0dda0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TestimonyHistory.vue
// module id = 426
// module chunks = 1